import { faFilterList } from '@fortawesome/pro-solid-svg-icons/faFilterList';
import { Button, ColourStateSolid, useLayout, useTranslation } from '@ukpostbox/frontend-framework';
import { useMailbox } from '../../../Providers/NewMailboxProvider';
import { MailboxFilterType } from '../../../Types/MailboxProviderTypes';

function MailboxFilter(props: MailboxFilterType) {
	const { t } = useTranslation();
	const { isTiny } = useLayout();
	const { userFilters, ShowFilters } = useMailbox();

	return (
		<Button
			squared
			colour={ColourStateSolid.Primary}
			title={
				Object.keys(userFilters).length > 0
					? t('actions.filtersCount', { count: Object.keys(userFilters).length })
					: t('actions.filters')
			}
			icon={faFilterList}
			iconOnly={isTiny}
			onClick={() => ShowFilters()}
		/>
	);
}

export { MailboxFilter };
